/* eslint-disable no-console */
import hello from 'hellojs';

import {
    APPLICATIONID,
    POLICIES,
    SCOPE,
    REDIRECTURI,
    SIGNINSIGNUPPOLICYNAME,
    RESPONSETYPE,
    HELLOJSSIGNINSIGNUPPOLICY,
    EDITPROFILEPOLICYNAME,
    HELLOJSEDITPROFILEPOLICY,
    PASSWORDRESETURL,
    TENANTNAME,
    TENANTURL,
} from './b2cConfig';

export default {

    init () {
        this.initSignInSignUp(hello);
        this.initEditProfile(hello);
        hello.init(
            {
                adB2CSignInSignUp: APPLICATIONID,
                adB2CEditProfile: APPLICATIONID,
            },
            {
                redirect_uri: REDIRECTURI,
                scope: `openid ${SCOPE}`,
                response_type: RESPONSETYPE,
            },
        );
        this.hellocopy = hello;
        this.helloNetwork = [
            {
                adB2CSignInSignUp: 'adB2CSignInSignUp',
                adB2CEditProfile: 'adB2CEditProfile',
            },
        ];
        this.helloNetwork.adB2CSignInSignUp = 'adB2CSignInSignUp';
        this.loginDisplayType = {
            PopUp: 'popup',
            None: 'none',
            Page: 'page',
            // Page: 'page' //default is popup, if using page option, user gets redirected to b2c login page then to redirect html.
        };
    },
    signInSignUp () {
        this.policyLogin(
            this.helloNetwork.adB2CSignInSignUp,
            this.loginDisplayType.Page,
        );
    },
    editProfile () {
        console.log('edit profile');
        this.policyLogin(
            this.helloNetwork.adB2CEditProfile,
            this.loginDisplayType.Page,
        );
    },
    resetPassword () {
        window.location.href = PASSWORDRESETURL;
    },
    signOut () {
        this.policyLogout(
            this.helloNetwork.adB2CSignInSignUp,
            POLICIES.signInSignUpPolicy,
        );
        this.policyLogout(
            this.helloNetwork.adB2CEditProfile,
            POLICIES.adB2CEditProfile,
        );
        // router.push('/');
    },
    policyLogin (network, displayType) {
        if (!displayType) {
            // eslint-disable-next-line no-param-reassign
            displayType = 'page';
        }

        hello(network)
            .login(
                {
                    display: displayType,
                    page_uri: REDIRECTURI,
                    state: 'SOTH',
                },
                this.log,
            )
            .then(
                (auth) => {
                    this.log(auth);
                    this.isSignedIn = true;
                },
                (e) => {
                    console.log(e);
                    if ('Iframe was blocked' in e.error.message) {
                        this.policyLogin(network, this.loginDisplayType.Page);
                    }
                },
            );
    },
    online (network) {
        const session = hello(network).getAuthResponse(network);
        const currentTime = new Date().getTime() / 1000;
        return session && session.access_token && session.expires > currentTime;
    },
    setSignInState (signedIn) {
        this.isSignedIn = signedIn;
    },
    policyLogout (network) {
        if (this.online(network)) {
            hello.logout(network, { force: true }).then(
                () => { },
                (e) => {
                    console.log(`Logout error: ${e.error.message}`);
                },
            );
        }
    },
    log (s) {
        // console.log('calling auth log function');
        if (typeof s.error !== 'undefined' && s.error !== null) {
            if (s.error.code === 'blocked') {
                // silentrenew(display: none) in case of expired token returns X-frame Options as DENY error
                console.log(
                    'There was an error in silent renewing the token. Please login again',
                );
            }
        } else {
            this.responseText = JSON.stringify(s, true, 2);
        }
    },
    logAPIResponse (s) {
        this.responseTextApi = JSON.stringify(s, true, 2);
    },
    // eslint-disable-next-line no-shadow
    initSignInSignUp (hello) {
        hello.init({
            adB2CSignInSignUp: {
                name: 'Azure Active Directory B2C',
                oauth: {
                    version: 2,
                    auth: `${TENANTURL}/tfp/${TENANTNAME}.onmicrosoft.com/${SIGNINSIGNUPPOLICYNAME}/oauth2/v2.0/authorize`,
                    grant: `${TENANTURL}/tfp/${TENANTNAME}.onmicrosoft.com/${SIGNINSIGNUPPOLICYNAME}/oauth2/v2.0/token`,
                },
                refresh: true,
                scope_delim: ' ',
                logout () {
                    // get id_token from auth response
                    const idToken = hello(HELLOJSSIGNINSIGNUPPOLICY).getAuthResponse()
                        .id_token;
                    // clearing local storage session
                    hello.utils.store(HELLOJSSIGNINSIGNUPPOLICY, null);

                    // redirecting to Azure B2C logout URI
                    window.location.href = `${TENANTURL}/${TENANTNAME}.onmicrosoft.com/oauth2/v2.0/logout?p=${SIGNINSIGNUPPOLICYNAME}&id_token_hint=${idToken}&post_logout_redirect_uri=${window.location.protocol}//${window.location.host}`;
                },
                xhr (p) {
                    const token = p.query.access_token;
                    delete p.query.access_token;
                    if (token) {
                        p.headers = {
                            Authorization: `Bearer ${token}`,
                        };
                    }

                    if (p.method === 'post' || p.method === 'put') {
                        // toJSON(p);
                        if (typeof p.data === 'object') {
                            // Convert the POST into a javascript object
                            try {
                                p.data = JSON.stringify(p.data);
                                p.headers['content-type'] = 'application/json';
                            } catch (e) {
                                console.log('unable to set data');
                            }
                        }
                    } else if (p.method === 'patch') {
                        hello.utils.extend(p.query, p.data);
                        p.data = null;
                    }
                    return true;
                },
                // Don't even try submitting via form.
                // This means no POST operations in <=IE9
                form: false,
            },
        });
    },
    // eslint-disable-next-line no-shadow
    initEditProfile (hello) {
        hello.init({
            adB2CEditProfile: {
                name: 'Azure Active Directory B2C',
                oauth: {
                    version: 2,
                    auth: `${TENANTURL}/tfp/${TENANTNAME}/${EDITPROFILEPOLICYNAME}/oauth2/v2.0/authorize`,
                    grant: `${TENANTURL}/tfp/${TENANTNAME}/${EDITPROFILEPOLICYNAME}/oauth2/v2.0/token`,
                },
                refresh: false,
                scope_delim: ' ',
                logout () {
                    // get id_token from auth response
                    // var id_token = hello(HELLOJSEDITPROFILEPOLICY).getAuthResponse().id_token; //check if needed
                    // clearing local storage session
                    hello.utils.store(HELLOJSEDITPROFILEPOLICY, null);
                },
            },
        });
    },
};
